<template>
    <section>
        <div :style="`z-index: 250; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}`">
            <v-alert
                v-model="notif.show"
                dismissible
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <v-dialog
            v-model="showDialog"
        >
            <v-card>
                <v-data-table
                    :items="items"
                    :headers="headers"
                    class="clinicTbl"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    fixed-header
                >
                    <template #top>
                        <v-card-title style="background-color: #009688; color: white;">
                            <v-chip style="font-weight: 700;">
                                {{ data.ACCT_N }}
                            </v-chip>&nbsp; {{ data.ACCT_M }}
                            <v-spacer />
                            <v-btn
                                v-if="showApproveAll"
                                color="warning"
                                @click="handleApproveAllPendingClinics"
                            >
                                <v-icon>{{ mdiCheck }}</v-icon> Approve All
                            </v-btn>
                            &nbsp;
                            <v-btn
                                v-if="data.STATUS === 'IN PROGRESS' || data.STATUS === 'ACTIVE'"
                                color="success"
                                @click="handleNewClinic()"
                            >
                                <v-icon>{{ mdiPlus }}</v-icon> Add Clinic
                            </v-btn>
                            &nbsp;
                            <v-btn
                                color="error"
                                @click="showDialog = false"
                            >
                                <v-icon>{{ mdiClose }}</v-icon> Close
                            </v-btn>
                        </v-card-title>
                    </template>
                    <template #item="{ item, index }">
                        <tr
                            @mouseenter="hoveredRow = index"
                            @mouseleave="hoveredRow = null"
                        >
                            <td
                                v-for="header in headers"
                                :key="header.value"
                                :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['ROW_N', 'ADDED_ON', 'APPROVED_ON', 'actions'].includes(header.value) ? 'center' : '' }"
                            >
                                <span style="text-wrap: nowrap;">
                                    <template v-if="header.value === 'ACCT_N'">
                                        <span :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', width: '100%', height: '100%' }">{{ item[header.value] }}</span>
                                    </template>
                                    <template v-else-if="['ADDED_ON', 'APPROVED_ON'].includes(header.value)">
                                        {{ formatDate(item[header.value]) }}
                                    </template>
                                    <template v-else-if="header.value === 'STATUS'">
                                        <div
                                            v-if="item.STATUS === 'ACTIVE'"
                                            style="width: 80px; color: #4caf50;"
                                        >
                                            <v-icon color="success">{{ mdiCheck }}</v-icon>Active
                                        </div>
                                        <div
                                            v-else
                                            :style="`width: 80px; color: ${item.STATUS === 'PENDING' ? '#fB9515' : '' }`"
                                        >
                                            <v-icon color="warning">{{ item.STATUS === 'PENDING' ? mdiTimerSand : '' }}</v-icon>Pending
                                        </div>
                                    </template>
                                    <template v-else-if="header.value === 'actions'">
                                        <div :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', width: '150px', height: '50px', paddingTop: '5px', textAlign: 'center' }">
                                            <v-tooltip
                                                v-if="item.STATUS === 'PENDING'"
                                                top
                                            >
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="success"
                                                        v-on="on"
                                                        @click="handleApprovePendingClinics(item)"
                                                    ><v-icon>{{ mdiCheck }}</v-icon></v-btn>
                                                </template>
                                                <span>Approve</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-on="on"
                                                        @click="handleShowHistory(item)"
                                                    ><v-icon>{{ mdiFileEye }}</v-icon></v-btn>
                                                </template>
                                                <span>Show History</span>
                                            </v-tooltip>
                                            <v-tooltip v-if="data.STATUS === 'IN PROGRESS' || (data.STATUS === 'ACTIVE' && item.STATUS === 'PENDING')" top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="error"
                                                        v-on="on"
                                                        @click="handleDeleteClinic(item)"
                                                    ><v-icon>{{ mdiTrashCan }}</v-icon></v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item[header.value] }}
                                    </template>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
        <NewClinic
            :show="dialog.new.status"
            :data="dialog.new.data"
            :notif="notif"
            @closeDialog="dialog.new.status = false"
            @refreshAcuList="$emit('refreshAcuList')"
        />
        <ShowHistory
            :show="dialog.history.status"
            :data="dialog.history.data"
            @closeDialog="dialog.history.status = false"
        />
        <DeleteClinic
            :show="dialog.delete.status"
            :data="dialog.delete.data"
            :notif="notif"
            @refreshAcuList="$emit('refreshAcuList')"
            @closeDialog="dialog.delete.status = false"
        />
    </section>
</template>

<script>
import { moment } from '../../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import NewClinic from './NewClinic.vue'
import ShowHistory from './ShowHistory.vue'
import DeleteClinic from './DeleteClinic.vue'
import {
    mdiCheck,
    mdiClose,
    mdiPlus,
    mdiTimerSand,
    mdiFileEye,
    mdiTrashCan
} from '@mdi/js'
export default {
    components: { NewClinic, ShowHistory, DeleteClinic },
    props: ['show', 'data'],
    data:()=>({
        mdiCheck,
        mdiClose,
        mdiPlus,
        mdiTimerSand,
        mdiFileEye,
        mdiTrashCan,
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        dialog: {
            new: {
                status: false,
                data: null
            },
            history: {
                status: false,
                data: null
            },
            delete: {
                status: false,
                data: null
            }
        },
        hoveredRow: null,
        items: [],
        headers: [
            { text: 'Number', value: 'ROW_N' },
            { text: 'Clinic Name', value: 'MSU_N', align: 'center' },
            { text: 'Status', value: 'STATUS' },
            { text: 'Added By', value: 'ADDED_BY', align: 'center' },
            { text: 'Added On', value: 'ADDED_ON' },
            { text: 'Approved By', value: 'APPROVED_BY', align: 'center' },
            { text: 'Approved On', value: 'APPROVED_ON' },
            { text: 'Actions', value: 'actions', align: 'center' }
        ],
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['viewAccountClinicsData', 'approveAccountClinicData']),
        isClinicHasPending() {
            return this.viewAccountClinicsData && this.viewAccountClinicsData.data.some(item => item.STATUS === 'PENDING')
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        },
        showApproveAll() {
            return (this.data.STATUS === 'PENDING' || this.data.STATUS === 'ACTIVE') && this.isClinicHasPending
        }
    },
    watch: {
        async approveAccountClinicData(newVal) {
            if (newVal && newVal.status === 200) {
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = 'Approved!'
                this.notif.show = true
                await this.viewAccountClinics({ ACCT_N: this.data.ACCT_N })
                // this.$emit('refreshAcuList', this.data.ACCT_N)
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
            }
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true,
            immediate: true
        },
        viewAccountClinicsData(newVal) {
            if (newVal && newVal.status === 200) {
                this.items = structuredClone(newVal.data)
                this.$emit('refreshAcuList', this.data.ACCT_N)
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
        this.$store.commit('VIEW_ACCOUNT_CLINICS', null)
    },
    methods: {
        ...mapActions(['viewAccountClinics', 'approveAccountClinic', 'acuActiveList']),
        handleDeleteClinic(item) {
            this.dialog.delete.status = true
            this.dialog.delete.data = item
        },
        handleApproveAllPendingClinics() {
            this.viewAccountClinicsData && this.viewAccountClinicsData.data.forEach(item => {
                if (item.STATUS === 'PENDING') {
                    this.handleApprovePendingClinics(item)
                }
            })
        },
        handleApprovePendingClinics(item) {
            this.approveAccountClinic({ 'ACCT_N': this.data.ACCT_N, 'MSU_C': item.MSU_C, 'TYPE': item.TYPE })
        },
        handleShowHistory(data) {
            this.dialog.history.data = data
            this.dialog.history.status = true
        },
        handleNewClinic() {
            this.dialog.new.status = true
            this.dialog.new.data = this.data
        },
        formatDate(date) {
            if (date)
                return moment(date).utcOffset('+0800').format('MMMM D, YYYY HH:mm:ss')
            else
                return '-'
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.clinicTbl > div > table > tbody > tr > td:last-child {
    position: sticky !important;
    right: 0;
    padding: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.clinicTbl .sticky-col {
    position: sticky;
    right: 0;
    background: white;
    z-index: 2;
    white-space: nowrap;
}
.clinicTbl .v-data-table__wrapper {
    overflow-y: auto;
    max-height: 70vh;
}
.clinicTbl > div > table > thead > tr > th:last-child {
    position: sticky !important;
    right: 0;
    z-index: 5 !important; /* Ensure the first column has a higher z-index */
    background: white;
}
</style>
